export default {
  name: 'Dashboard',
  data() {
    return {
      monitoredUrls: [],
      recentSnapshots: [],
      loading: true,
      formCollapsed: true,
      pastCollapsed: true,
      showSuccessBanner: false,
      deleteConfirmation: {
        show: false,
        urlId: null,
        urlName: ''
      },
      newUrl: {
        name: '',
        url: '',
        notification_email: '',
        tournament_start_date: ''
      }
    }
  },
  computed: {
    upcomingUrls() {
      return this.monitoredUrls.filter(url => {
        const days = this.daysUntilTournament(url.tournament_start_date)
        return days === null || days >= 0
      })
    },
    pastUrls() {
      return this.monitoredUrls.filter(url => {
        const days = this.daysUntilTournament(url.tournament_start_date)
        return days !== null && days < 0
      })
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const response = await fetch('/monitored_urls.json')
        const data = await response.json()
        this.monitoredUrls = data.monitored_urls || []
        this.recentSnapshots = data.recent_snapshots || []
        this.loading = false
      } catch (error) {
        console.error('Error loading data:', error)
        this.loading = false
      }
    },
    async addUrl() {
      if (!this.newUrl.name || !this.newUrl.url || !this.newUrl.tournament_start_date) {
        alert('Please fill in name, URL, and tournament start date')
        return
      }

      try {
        const response = await fetch('/monitored_urls', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ monitored_url: this.newUrl })
        })

        if (response.ok) {
          this.newUrl = { name: '', url: '', notification_email: '', tournament_start_date: '' }
          this.loadData()
          this.formCollapsed = true
          this.showSuccessBanner = true
          setTimeout(() => {
            this.showSuccessBanner = false
          }, 5000)
        } else {
          alert('Failed to add URL')
        }
      } catch (error) {
        console.error('Error adding URL:', error)
        alert('Error adding URL')
      }
    },
    removeUrl(id) {
      const url = this.monitoredUrls.find(u => u.id === id)
      this.deleteConfirmation = {
        show: true,
        urlId: id,
        urlName: url ? url.name : ''
      }
    },
    async confirmDelete() {
      const id = this.deleteConfirmation.urlId
      this.deleteConfirmation.show = false

      try {
        const response = await fetch(`/monitored_urls/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          }
        })

        if (response.ok) {
          this.loadData()
        } else {
          alert('Failed to remove URL')
        }
      } catch (error) {
        console.error('Error removing URL:', error)
        alert('Error removing URL')
      }
    },
    cancelDelete() {
      this.deleteConfirmation = {
        show: false,
        urlId: null,
        urlName: ''
      }
    },
    async checkNow(id) {
      try {
        const response = await fetch(`/monitored_urls/${id}/check_now`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          }
        })

        if (response.ok) {
          // Success - silently refresh
        } else {
          alert('Failed to check URL')
        }
      } catch (error) {
        console.error('Error checking URL:', error)
        alert('Error checking URL')
      }
    },
    formatDate(dateString) {
      if (!dateString) return 'Never'
      return new Date(dateString).toLocaleString()
    },
    formatSimpleDate(dateString) {
      if (!dateString) return 'Not set'
      return new Date(dateString).toLocaleDateString()
    },
    daysUntilTournament(tournamentDate) {
      if (!tournamentDate) return null
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const tournament = new Date(tournamentDate)
      tournament.setHours(0, 0, 0, 0)
      const diffTime = tournament - today
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },
    getCheckFrequency(tournamentDate) {
      const days = this.daysUntilTournament(tournamentDate)
      if (days === null || days < 0) return 'Not scheduled'
      if (days <= 1) return '5x daily (9am, 12pm, 3pm, 6pm, 10pm PT)'
      if (days <= 4) return '4x daily (9am, 12pm, 5pm, 10pm PT)'
      if (days <= 7) return '3x daily (9am, 3pm, 10pm PT)'
      if (days <= 13) return '2x daily (10am, 10pm PT)'
      return 'Once daily (10am PT)'
    }
  },
  template: `
    <div>
      <!-- Delete Confirmation Modal -->
      <div v-if="deleteConfirmation.show" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;" @click.self="cancelDelete">
        <div style="background: white; border-radius: var(--radius-lg); padding: 2rem; max-width: 500px; box-shadow: var(--shadow-lg);">
          <h3 style="margin: 0 0 1rem 0; color: var(--text-primary);">
            <i class="bi bi-exclamation-triangle" style="color: var(--accent-color);"></i> Confirm Deletion
          </h3>
          <p style="color: var(--text-secondary); margin-bottom: 1.5rem;">
            Are you sure you want to remove <strong>{{ deleteConfirmation.urlName }}</strong>? This action cannot be undone.
          </p>
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button @click="cancelDelete" class="btn-outline-primary" style="padding: 0.5rem 1.5rem;">
              Cancel
            </button>
            <button @click="confirmDelete" class="btn-danger" style="padding: 0.5rem 1.5rem;">
              <i class="bi bi-trash"></i> Delete
            </button>
          </div>
        </div>
      </div>

      <!-- Success Banner -->
      <transition name="fade">
        <div v-if="showSuccessBanner" style="position: fixed; top: 20px; right: 20px; background: linear-gradient(135deg, #10b981 0%, #059669 100%); color: white; padding: 1rem 1.5rem; border-radius: var(--radius-md); box-shadow: 0 10px 25px rgba(16, 185, 129, 0.3); z-index: 1001; display: flex; align-items: center; gap: 0.75rem; animation: slideIn 0.3s ease-out;">
          <i class="bi bi-check-circle-fill" style="font-size: 1.5rem;"></i>
          <div>
            <div style="font-weight: 600; margin-bottom: 0.125rem;">Schedule Added!</div>
            <div style="font-size: 0.875rem; opacity: 0.95;">Monitoring will begin shortly</div>
          </div>
        </div>
      </transition>

      <!-- Add New URL Form -->
      <div class="add-url-form">
        <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;" @click="formCollapsed = !formCollapsed">
          <h2 style="margin: 0;">➕ Add New Schedule to Monitor</h2>
          <i :class="formCollapsed ? 'bi bi-chevron-down' : 'bi bi-chevron-up'" style="font-size: 1.5rem; color: var(--primary-color);"></i>
        </div>
        <form v-show="!formCollapsed" @submit.prevent="addUrl" style="margin-top: 1.5rem;">
          <div class="form-group">
            <label>Name/Description</label>
            <input v-model="newUrl.name" type="text" placeholder="e.g., Spring Tournament 2026" required>
          </div>
          <div class="form-group">
            <label>Tournament URL</label>
            <input v-model="newUrl.url" type="url" placeholder="https://..." required>
          </div>
          <div class="form-group">
            <label>Tournament Start Date <span style="color: var(--accent-color);">*</span></label>
            <input v-model="newUrl.tournament_start_date" type="date" required>
            <small style="font-size: 0.75rem; color: var(--text-secondary); display: block; margin-top: 0.25rem;">
              Check frequency adjusts automatically based on proximity
            </small>
          </div>
          <div class="form-group">
            <label>Notification Email <span style="font-size: 0.75rem; color: var(--text-light);">(optional)</span></label>
            <input v-model="newUrl.notification_email" type="email" placeholder="Leave empty to use account email">
          </div>
          <button type="submit" class="btn-primary">Add Schedule</button>
        </form>
      </div>

      <!-- Loading State -->
      <div v-if="loading" style="text-align: center; padding: 3rem;">
        <div style="display: inline-block; width: 3rem; height: 3rem; border: 3px solid var(--border-color); border-top-color: var(--primary-color); border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
      </div>

      <!-- URLs List -->
      <div v-else>
        <div v-if="monitoredUrls.length === 0" class="alert alert-info">
          <i class="bi bi-info-circle"></i> No schedules are being monitored yet. Add one above to get started!
        </div>

        <!-- Upcoming Tournaments -->
        <div v-if="upcomingUrls.length > 0" style="margin-top: 2rem;">
          <h2 style="font-size: 1.5rem; font-weight: 600; margin-bottom: 1.5rem; color: var(--primary-color);">
            <i class="bi bi-calendar-check"></i> Upcoming Tournaments ({{ upcomingUrls.length }})
          </h2>
          <div v-for="url in upcomingUrls" :key="url.id" class="url-card">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem;">
              <div style="flex: 1;">
                <div class="url-title">{{ url.name }}</div>
                <a :href="url.url" target="_blank" rel="noopener" class="url-link">
                  <i class="bi bi-link-45deg"></i> {{ url.url }}
                </a>

                <div class="url-meta">
                  <div class="meta-item">
                    <i class="bi bi-calendar-event"></i>
                    <span>{{ formatSimpleDate(url.tournament_start_date) }}</span>
                    <span v-if="daysUntilTournament(url.tournament_start_date) !== null && daysUntilTournament(url.tournament_start_date) >= 0" class="badge badge-primary" style="margin-left: 0.5rem;">
                      {{ daysUntilTournament(url.tournament_start_date) }} days away
                    </span>
                  </div>
                </div>

                <div style="margin-top: 0.75rem; padding: 0.75rem; background: var(--bg-color); border-radius: var(--radius-sm); font-size: 0.875rem;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                    <i class="bi bi-clock"></i>
                    <strong>Check Frequency:</strong>
                    <span style="color: var(--primary-color);">{{ getCheckFrequency(url.tournament_start_date) }}</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                    <i class="bi bi-arrow-clockwise"></i>
                    <strong>Next Check:</strong>
                    <span>{{ formatDate(url.next_check_at) }}</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                    <i class="bi bi-check-circle"></i>
                    <strong>Last Checked:</strong>
                    <span>{{ formatDate(url.last_checked_at) }}</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 0.5rem;">
                    <i class="bi bi-file-text"></i>
                    <strong>Status:</strong>
                    <span v-if="url.schedule_available" class="badge badge-success">Schedule Available</span>
                    <span v-else class="badge badge-warning">Waiting for Schedule</span>
                  </div>
                  <div v-if="url.notification_email" style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
                    <i class="bi bi-envelope"></i>
                    <strong>Notifications:</strong>
                    <span>{{ url.notification_email }}</span>
                  </div>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                <button @click="checkNow(url.id)" class="btn-outline-primary" style="white-space: nowrap; padding: 0.5rem 1rem;">
                  <i class="bi bi-arrow-repeat"></i> Check Now
                </button>
                <button @click="removeUrl(url.id)" class="btn-danger" style="white-space: nowrap; padding: 0.5rem 1rem;">
                  <i class="bi bi-trash"></i> Remove
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Past Tournaments -->
        <div v-if="pastUrls.length > 0" style="margin-top: 2rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; margin-bottom: 1.5rem;" @click="pastCollapsed = !pastCollapsed">
            <h2 style="margin: 0; font-size: 1.5rem; font-weight: 600; color: var(--text-secondary);">
              <i class="bi bi-calendar-x"></i> Past Tournaments ({{ pastUrls.length }})
            </h2>
            <i :class="pastCollapsed ? 'bi bi-chevron-down' : 'bi bi-chevron-up'" style="font-size: 1.5rem; color: var(--text-secondary);"></i>
          </div>
          <div v-show="!pastCollapsed">
            <div v-for="url in pastUrls" :key="url.id" class="url-card" style="opacity: 0.8;">
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem;">
                <div style="flex: 1;">
                  <div class="url-title">{{ url.name }}</div>
                  <a :href="url.url" target="_blank" rel="noopener" class="url-link">
                    <i class="bi bi-link-45deg"></i> {{ url.url }}
                  </a>

                  <div class="url-meta">
                    <div class="meta-item">
                      <i class="bi bi-calendar-event"></i>
                      <span>{{ formatSimpleDate(url.tournament_start_date) }}</span>
                      <span style="margin-left: 0.5rem; color: var(--text-light); font-size: 0.75rem;">
                        (Past)
                      </span>
                    </div>
                  </div>

                  <div style="margin-top: 0.75rem; padding: 0.75rem; background: var(--bg-color); border-radius: var(--radius-sm); font-size: 0.875rem;">
                    <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                      <i class="bi bi-check-circle"></i>
                      <strong>Last Checked:</strong>
                      <span>{{ formatDate(url.last_checked_at) }}</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 0.5rem;">
                      <i class="bi bi-file-text"></i>
                      <strong>Status:</strong>
                      <span v-if="url.schedule_available" class="badge badge-success">Schedule Available</span>
                      <span v-else class="badge badge-warning">Waiting for Schedule</span>
                    </div>
                    <div v-if="url.notification_email" style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
                      <i class="bi bi-envelope"></i>
                      <strong>Notifications:</strong>
                      <span>{{ url.notification_email }}</span>
                    </div>
                  </div>
                </div>

                <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                  <button @click="removeUrl(url.id)" class="btn-danger" style="white-space: nowrap; padding: 0.5rem 1rem;">
                    <i class="bi bi-trash"></i> Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent Changes -->
      <div v-if="recentSnapshots.length > 0" style="margin-top: 3rem;">
        <div style="background: var(--card-bg); border-radius: var(--radius-lg); padding: 2rem; box-shadow: var(--shadow-sm);">
          <h2 style="font-size: 1.5rem; font-weight: 600; margin-bottom: 1.5rem;">
            <i class="bi bi-clock-history"></i> Recent Schedule Changes
          </h2>
          <div v-for="snapshot in recentSnapshots" :key="snapshot.id" style="padding: 1rem; margin-bottom: 1rem; background: var(--bg-color); border-radius: var(--radius-md); border-left: 4px solid var(--accent-color);">
            <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">
              <i class="bi bi-calendar3"></i> {{ formatDate(snapshot.checked_at) }}
            </div>
            <div style="color: var(--text-primary);">{{ snapshot.ai_summary }}</div>
          </div>
        </div>
      </div>
    </div>
  `
}
